var _defs, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAccommodation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50.01 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".e{fill:#0eb5e4;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("g", {
    id: "d"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M0,18.45v-.1c.12-.07,.26-.12,.37-.2C7.16,13.16,13.94,8.16,20.72,3.16c1.42-1.05,2.85-2.1,4.29-3.16l10.26,7.56V3.16h8.78v.57c0,3.29,0,6.57,0,9.86,0,.32,.09,.53,.36,.72,.97,.69,1.92,1.4,2.87,2.1,.9,.66,1.8,1.33,2.73,2.02l-1.74,2.35-1.29-.93v30.15H3.03V19.86l-1.29,.92-1.74-2.32Zm45.04,29.59c0-.14,.02-.24,.02-.34,0-9.55,0-20.11,0-29.66,0-.3-.12-.47-.35-.63-6.09-4.48-13.19-9.97-19.27-14.47-.33-.25-.54-.25-.87,0-6.07,4.49-13.15,9.97-19.23,14.44-.3,.22-.39,.45-.39,.81,0,9.44,0,19.88,0,29.32v.54H45.04Zm-2.71-42.73h-5v4l5,4V5.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M8.9,44.1V20.74h1.91v5.82c1.11,0,3.16,0,4.21,0,.62,0,1.25-.04,1.85,.06,2.63,.43,4.21,2.86,3.59,5.45-.02,.09-.04,.19-.06,.33h20.69v11.71h-1.87v-2.87H10.83v2.86h-1.93Zm30.27-9.78H10.84v5h28.33v-5Zm-28.33-1.9c1.82,0,4.81,0,6.57,0,1.11,0,1.93-.89,1.92-2.06,0-1.17-.81-2.03-1.94-2.04-1.55-.01-3.1,0-4.66,0-.21,0-1.67,0-1.9,0v4.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M32.31,11.94v11.66h-14.59V11.94h14.59Zm-12.98,1.37v9h12V13.32h-12Z"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccommodation);
export default __webpack_public_path__ + "static/media/Accommodation.941e9b5c94dfca8242a4495a6ed14b78.svg";
export { ForwardRef as ReactComponent };